import { useEffect, useState } from 'react';

/**
 * "m:ss" since a start time, ticking every second; empty when there's no start time.
 */
export const useElapsed = (since: Date | null) => {
    const [now, setNow] = useState(Date.now());

    useEffect(() => {
        if (!since) {
            return;
        }
        const timer = window.setInterval(() => setNow(Date.now()), 1000);
        return () => window.clearInterval(timer);
    }, [since]);

    if (!since) {
        return '';
    }
    const seconds = Math.max(0, Math.floor((now - since.getTime()) / 1000));
    const minutes = Math.floor(seconds / 60);
    if (minutes >= 60) {
        return `${Math.floor(minutes / 60)}h ${minutes % 60}m`;
    }
    return `${minutes}:${String(seconds % 60).padStart(2, '0')}`;
}
